import React, { Fragment, useState } from 'react'
import ImgsViewer from 'react-images-viewer'
import styled from 'styled-components';

const Mini = styled.img`
  position: relative;
  display: table-row;
  margin-bottom: 8px;
  text-align: center;
  cursor: pointer;
  `;

  const Caption = styled.figcaption`
  display: table-caption;
  caption-side: bottom ;
  font-size: 80%;
  color: white;
  background-color: rgb(27, 27, 27);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 20px;
  padding-bottom: 10px;
  padding-top: 0px;
  `;

  const Fig = styled.figure`
  cursor: pointer;
  display: table;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
  background-color: rgb(27, 27, 27);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-top: 10px;
  transition: transform .2s ease;
  &:hover {
    transform: scale(1.02);
  }
  `;

const ImageViewer = ({
  imgs,
  maxHeight
}) => {

  const [isOpen, setIsOpen] = useState(false)

  return (
    <Fragment>
      {imgs.map((img, ind) => <Fig onClick={() => {
        setIsOpen(true)
      }} key={'img_' + ind}><Mini style={{maxHeight: maxHeight || 400}} alt={img.src} src={img.src} />
      <Caption>{img.caption}</Caption>
      </Fig>)}
      <ImgsViewer
        backdropCloseable={true}
        currImg={0}
        showImgCount={false}
        imgs={imgs}
        isOpen={isOpen}
        // onClickPrev={this.gotoPrevImg}
        // onClickNext={this.gotoNextImg}
        onClose={() => setIsOpen(false)}
      />
    </Fragment>
  );
};

export default ImageViewer